import * as THREE from "three";
import {Node, NodeConstructor} from "../../Node";
import {PString} from "../../properties/PString";
import {PNumber} from "../../properties/PNumber";
import 'three/examples/js/lights/RectAreaLightUniformsLib.js';
import "three/examples/js/helpers/RectAreaLightHelper";
import {json} from "../../../global";
import {ThreeMixin} from "../ThreeMixin";
import {LightJson} from "../LightJson";

export class ShadowNode extends ThreeMixin<NodeConstructor, THREE.LightShadow>(Node) {

    id: number;
    previousShadow3d: THREE.LightShadow;
    parent: LightJson;

    constructor(parentNode: LightJson) {
        super();
        this.parent = parentNode;
        // folgendes, damit die Vergleichswerte vorher/nachher initialisiert sind
        this.changed('json', () => this.toJSON());
        this.changed('Type');
    }

    // @ts-ignore
    get threeValue() {
        return this.parent.threeValue?.shadow;
    }

    set threeValue(v) {
        throw new Error('not intended');
    }

    fillWithDefaults() {
        throw new Error('not intended');
        return this;
    }

    fromJSON(json: json = {}, filter = p => p.type) {
        return super.fromJSON(json, filter);
    }

    fromThree(threeValue) {
        // if (threeValue!==this.threeValue) {
        //     debugger;
        // }
        return super.fromThree(threeValue);
    }

    toThree(threeValue) {
        // if (threeValue!==this.threeValue) {
        //     debugger;
        // }
        const props = this.getProperties().filter(p => p.isThree !== undefined && p.isThree(p));
        props.forEach(p => p.toThree(threeValue));
    }

    getProperties() {
        if (this._properties == null || this.previousShadow3d !== this.threeValue) {
            this._resetProperties();
            this.previousShadow3d = this.threeValue;
        }
        return this._properties;
    }

    updateScene() {
        this._dataChanged = {};
        const changedJson = this.changed('json', () => this.toJSON());
        if (changedJson) {
            this.parent.updateScene();
            this.threeValue.needsUpdate = true;
        }
    }

    /**
     * Dient der Strukturierung und Ergänzung vorhandener Properties, welche mittels Reflektion aus material3d ermittelt werden
     */
    static propertyGruppierung = [
        {
            name: "mapSize",
        },
        {
            name: "bias",
            propertyClass: PNumber,
            default: 0,
            decimals: 4,
            min: -0.01,
            max: 0.01,
            comment: I18N("scene editor:shadownode bias comment")
        },
        {
            name: "normalBias",
            propertyClass: PNumber,
            default: 0,
            min: -2,
            max: 2,
            comment: I18N("scene editor:shadownode normal bias comment")
        },
        {
            name: "radius",
            propertyClass: PNumber,
            default: 1,
            min: 0,
            max: 50,
            comment: I18N("scene editor:shadownode radius comment"),
            showInEditor: p => ![THREE.BasicShadowMap, THREE.PCFSoftShadowMap].includes(APP.renderer.shadowMap.type)
        },
        {
            name: "blurSamples",
            propertyClass: PNumber,
            default: 0,
            decimals: 0,
            min: 0,
            max: 40,
            comment: I18N("scene editor:shadownode blur samples comment"),
            showInEditor: p => THREE.VSMShadowMap === APP.renderer.shadowMap.type,
        },
    ];

    createProperties() {
        let properties = this.getGenericPropertiesFromThreejs(this.threeValue, (key, value) => {
            if (key == 'mapSize') {
                return new (class extends PString {
                    toThree(threeValue) {
                        const s = parseInt(this.get(), 10);
                        threeValue.mapSize.set(s, s);
                    }

                    fromThree(threeValue) {
                        this.set((threeValue.mapSize?.x ?? 512) + '');
                    }
                })({
                    name: "mapSize",
                    selectOptions: _.range(2, 15).map(i => Math.pow(2, i) + ''),
                    comment: I18N("scene editor:shadownode map size comment"),
                    node: this,
                });
            }
            if (/^(autoUpdate|camera|map|mapPass|matrix|needsUpdate)$/g.test(key)) {
                return null;
            }
            return undefined;
        });
        return this.orderAndGroup(
            ShadowNode.propertyGruppierung,
            properties
        );
    }

    getTableName() {
        return 'LightJson';
    }

}
